module.exports = __webpack_public_path__ + "img/ec_public.879370a0.svg";